<template>
    <div class="input-area">
        <form @submit.prevent="verify">
            <p>この操作は再認証が必要です。<br>あなたのパスワードを入力してください。</p>
            <div class="form-item">
                <input-text type="password" v-model="password" :autocomplete="'new-password'"></input-text>
                <button type="button" class="btn primary get" :disabled="!password" @click="verify()">送信</button>
            </div>
        </form>
    </div>
</template>

<script lang="ts">
import { useAuth } from '@/composable/auth/auth';
import { defineComponent, ref } from 'vue';
export default defineComponent({
    emits: {
        result(result: boolean): boolean {
            return result
        }
    },
    setup(props, context) {
        const { verifyPassword } = useAuth()
        let password = ref('')

        const verify = async () => {
            if (!password.value) {
                return
            }
            context.emit('result', await verifyPassword(password.value));
        }

        return {
            verify,
            password
        }
    }
})
</script>

<style lang="scss" scoped>
.input-area{
    width: 300px;
}
.form-item {
    display: flex;
    width: 100%;
    .inputtext-container{
        flex: 1;
    }

    button{
        padding: 0 20px;
        margin-left: 5px;
    }
}
</style>
